module.exports = __webpack_public_path__ + "img/hk.a70c837b.png";